import { SxProps, Typography, useTheme } from '@mui/material';
import { PropsWithChildren } from 'react';
import { useIntl } from 'react-intl';

import { DataGridLayout, WorkflowMessage } from '@verantos-dev/shared-components';
import { CohortCharacteristicsResultType } from '@verantos-dev/types-cohorts';

import {
  cohortCharacteristicResultMessageeEmptyMap,
  cohortCharacteristicResultTitleEmptyMap,
  cohortCharacteristicResultTypeToSectionNameMap,
} from '../constants';

export const ChartLayout = ({
  children,
  heading,

  chartType,
  isEmpty,
  skipHeight = false,
  chartTitleText,
  sx = {},
}: PropsWithChildren<{
  heading: string;
  chartType: CohortCharacteristicsResultType;
  isEmpty?: boolean;
  skipHeight?: boolean;
  chartTitleText?: string;
  sx?: SxProps;
}>) => {
  const theme = useTheme();
  const intl = useIntl();

  return isEmpty ? (
    <WorkflowMessage
      id="data-grid-error"
      sx={{
        width: '100%',
        height: '100%',
        minHeight: '300px',
        ...sx,
      }}
      title={intl.formatMessage({ id: cohortCharacteristicResultTitleEmptyMap[chartType] })}
      message={intl.formatMessage({ id: cohortCharacteristicResultMessageeEmptyMap[chartType] })}
    />
  ) : (
    <DataGridLayout
      id="cohort-characteristics-layout"
      sx={{
        height: skipHeight ? undefined : 350,
        padding: `${theme.spacing(4)} ${theme.spacing(6)}`,
        ...sx,
      }}
    >
      <Typography variant="h6">
        {heading ||
          intl.formatMessage(
            { id: cohortCharacteristicResultTypeToSectionNameMap[chartType] },
            { chartTitleText }
          )}
      </Typography>
      {children}
    </DataGridLayout>
  );
};
